
import axios from 'axios'
import library from '../../../utils/Library'

export const getUserStatusCorpEntities = async (params) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') + '/getUserStatusCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
  })
}
